import React, { useEffect } from "react";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BottomPopUp = ({ isOpen, onClose, children, height, opacity }) => {
  //
  useEffect(() => {
    const handleScroll = (event) => {
      if (isOpen) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };

    if (isOpen) {
      // Disabling the scrolling on the body background element when the popup is open
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
      document.body.addEventListener("scroll", handleScroll, {
        passive: false,
      });
    } else {
      // Enable scrolling on the body element when the popup is closed
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
      document.body.style.overflow = "auto";
      document.body.removeEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup function to enable scrolling when component unmounts
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
      document.body.style.overflow = "auto";
      document.body.removeEventListener("scroll", handleScroll);
    };
  }, [isOpen]);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black z-40 overflow-hidden border ${
            opacity ? opacity : "opacity-100"
          }`}
          onClick={onClose}
        ></div>
      )}
      {/* BottomPopUp */}
      <div
        className={`fixed bottom-0 left-0 w-full bg-black z-[999999] transition-transform duration-300 transform ${
          isOpen ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <button
          className="!text-gray-600 w-full flex justify-end !pr-5"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faClose} className="text-white text-[23px]" />
        </button>

        <div className={` ${height && height}`}>{children}</div>
      </div>
    </>
  );
};

export default BottomPopUp;
